// extracted by mini-css-extract-plugin
export var cartIcon = "_ny-0";
export var cartIconContainer = "_ny-1";